class PostEditor {
  templateName = 'post_editor__post-editor'
  tabPostEditor = 'post_editor__tab_post_editor'
  tabContentAnalytics = 'post_editor__tab_content_analytics'
  tabEngagement = 'post_editor__tab_engagement'
  tabHistory = 'post_editor__tab_history'
  tabNotes = 'post_editor__tab_notes'

  constructor(app, container, imageCssVar, activeTab = 'Post Editor') {
    this.app = app;
    this.container = container;
    this.imageCssVar = imageCssVar;
    this.template = _.template(this.app.templates[this.templateName]);
    this.data = {};
    this.activeTab = activeTab;
    this.menus = [
      'Post Editor',
      'Content Analytics',
      'Notes',
      'History',
    ];
  }

  setImageObserverManager(ImageObserverManager) {
    this.observerManager = ImageObserverManager;
  }

  setData(data) {
    console.log(data);
    this.data = data;
  }

  updateData(key, value) {
    this.data[key] = value;
    if(key === 'proplus' || key === 'pro') {
      this.editor.find(`[data-plan="${key}"] .svg-object`).attr('data-src', value);
      this.observe();
    }
    if(key === 'image') {
      this.editor.find(`[data-plan="free"] [data-type="image"]`).attr('data-src', value);
      this.observe();
    }
  }

  getData(data) {
    const planTab = this.editor.find('[data-plan]').closest('.tab-image-plan.active');
    const plan = planTab.find('[data-plan]').data('plan');
    return {...this.data, ...{plan: plan}};
  }

  setMenus(menus) {
    this.menus = menus;
  }

  async getTabs() {
    if(this.app.isEmpty(this.app.calendar)) {
      await this.app.apis['calendar'].fetch();
    }

    const approvalMode = this.app.calendar.has_collaborator;

    let tabs = {};
    if (this.app.isEmpty(this.data.status)) {
      this.data.status = '';
    }

    this.data.saveButtonText = 'Update Post';
    this.data.headerText = 'Post';

    if (this.data.segments === 'custom') {
      this.data.saveButtonText = 'Update Custom Post';
    } else if (this.data.segments === 'article') {
      this.data.saveButtonText = 'Update Post';
      this.data.headerText = 'Article Post';
    }

    if (this.data.segments === 'custom') {
      this.data.saveButtonText = 'Update Custom Post';
    }

    if (this.data.status.toLowerCase() === 'posted' || this.data.status.toLowerCase() === 'incomplete' || this.data.status.toLowerCase() === 'posted/rescheduled') {
      this.data.saveButtonText = false;
      this.activeTab = this.app.isEmpty(this.activeTab) || this.activeTab === 'Post Editor' ? 'Post Editor' : this.activeTab;
      this.menus = [
        'Post Editor',
        'Content Analytics',
        'History',
      ];
    } else if (this.data.status.toLowerCase() === 'failed') {
      this.data.saveButtonText = false;
      this.activeTab = this.app.isEmpty(this.activeTab) || this.activeTab === 'Post Editor' ? 'History' : this.activeTab;
      this.menus = [
        'History',
      ];
    } else {
      this.menus = [
        'Post Editor',
        'Content Analytics',
      ];
    }
    if(approvalMode) {
      this.menus.push('Notes');
    }

    if(this.app.approvalSystem) {
      this.data.saveButtonText = false;
    }

    this.menus.forEach(function (tab) {
      const key = tab.replace(/\s/g, "_").toLowerCase();
      tabs[key] = {'key': tab.replace(/\s/g, "_").toLowerCase(), 'name': tab};
    })
    return {'menus': tabs};
  }

  renderTabPostEditor() {
    const app = this.app;
    const self = this;
    const $tabEditor = $('#tab_post_editor', this.editor);

    const page = _.template(this.app.templates['post_editor__partials-footer-text-versions']);
    this.data.placeholderPostEditorFooter = page(this.data);

    const postNetworks = _.template(app.templates['calender__partials-post-networks']);
    this.data.postNetworks = postNetworks(this.data);

    const template = _.template(this.app.templates[this.tabPostEditor]);
    const $editor = $(
        template(this.data)
    );
    $editor.appendTo($tabEditor);

    const textAreas = $('textarea', $tabEditor);
    const charCount = $('[data-character-count]', $tabEditor)[0];

    textAreas.each(function (index, textarea) {
      textarea.addEventListener('input', () => {
        const name = this.name;
        self.data[name] = this.value;
        app.updateCharCount(textarea, charCount)
      });
    });

    $editor.off('click.tab').on('click.tab', `a[data-bs-toggle='tab']`, function () {
      let $this = $(this);
      const href = $this.attr('href');
      const tab = $(href);
      const textarea = tab.find('textarea')[0];
      if (href === '#tab_long_version') {
        app.updateCharCount(textarea, charCount);
      }
      if (href === '#tab_short_version') {
        app.updateCharCount(textarea, charCount);
      }
    });

    $editor.find(`a[data-bs-toggle='tab'][href='#tab_long_version']`).trigger('click');

    $('input[name="postTime"]', $editor).daterangepicker({
      singleDatePicker: true,
      autoUpdateInput: false,
      timePicker: true,
      showDropdowns: true,
      opens: 'left',
      locale: {
        format: 'MM/DD/YYYY hh:mm A'
      },
      "cancelClass": "btn-secondary"
    }, function (start, end, label) {
      $('input[name="postTime"]', $editor).val(start.format('YYYY-MM-DD HH:mm'));
      const userTimeZone = app.apis['user'].get().timezone;
      self.data.d = moment.tz(start.format('YYYY-MM-DD HH:mm'), userTimeZone).format();
    });

    new SimpleBar($tabEditor[0], {autoHide: true});
    return $editor;
  }

  showLoader(container) {
    const $tpl = $('<div class="m-progress m-auto position-absolute start-0 end-0 top-0 bottom-0 m-auto"></div>');
    this.loader = $tpl.appendTo(container);
  }

  removeLoader(container) {
    $('.m-progress', container).remove();
  }

  async renderEngagement() {
    const self = this;
    const $tabEngagement = $('#tab_engagement', this.editor);
    try {
      const stats = await this.app.apis['post'].stat(this.data.id);

      // Add new twitter icon
      _.each(stats.socials, function (social) {
        social.networkIcon = social.network;
        if (social.network === 'twitter') {
          social.networkIcon = 'x-twitter';
        }
      })

      const template = _.template(this.app.templates[this.tabEngagement]);
      const $tab = $(template({
        'icons': {
          "like": 'thumbs-up',
          "praise": 'heart',
          "maybe": 'heart',
          "interest": 'heart',
          "empathy": 'heart',
          "appreciation": 'heart'
        },
        'socials': stats.socials
      }));
      $tab.appendTo($tabEngagement);
    } catch (error) {
      const noRecordsOptions = {
        title: 'Error fetching engagement data',
        description: `This can be because of several reasons, you can try again or visit help section, ${error}`,
        addButton: {
          text: 'Retry',
          onClick: () => {
            self.placeholder.destroy();
            self.renderTabContentAnalytics();
          }
        },
        help: {
          text: 'Need Help ?',
          onClick: () => {
            console.log('Help clicked');
          }
        },
      };

      this.placeholder = new NoRecordsPlaceholder(this.app, $tabEngagement, noRecordsOptions);
      this.placeholder.render();
    }

  }

  renderTabContentAnalytics() {
    const self = this;
    const template = _.template(this.app.templates[this.tabContentAnalytics]);
    const $tab = $(
        template(this.data)
    );
    const $tabContentAnalytics = $('#tab_content_analytics', this.editor);
    $tab.appendTo($tabContentAnalytics);
    this.showLoader($tabContentAnalytics);
    this.renderEngagement().then(function () {
      self.removeLoader($tabContentAnalytics);
      new SimpleBar($tabContentAnalytics[0], {autoHide: true});
    }).catch(function (error) {
      self.removeLoader($tabContentAnalytics);
    });
    return $tab;
  }

  async renderHistory() {
    const $tabHistory = $('#tab_history', this.editor);
    this.showLoader($tabHistory);

    const response = await this.app.apis['post'].history(this.data.id);

    const data = HistoryFormatter.formattedData(response, this.app);

    const template = _.template(this.app.templates[this.tabHistory]);
    const $tab = $(template(data));

    $tab.appendTo($tabHistory);
    this.removeLoader($tabHistory);

    new SimpleBar($tabHistory[0], {autoHide: true});
  }

  async renderNotes() {
    const $tabNotes = $('#tab_notes', this.editor);
    this.showLoader($tabNotes);

    const response = await this.app.apis['post'].approveLog(this.data.id);
    let data = NotesFormatter.formattedData(response, this.app);
    if(this.app.isEmpty(data.notes)) {
      // Handle errors and provide options for retry
      const noRecordsOptions = {
        class: '',
        title: 'No notes',
        description: `No notes found for this post`,
      };
      this.placeholder = new NoRecordsPlaceholder(this.app, $tabNotes, noRecordsOptions);
      this.placeholder.render();
    } else {
      const template = _.template(this.app.templates[this.tabNotes]);
      const $tab = $(template(data));
      $tab.appendTo($tabNotes);
    }

    this.removeLoader($tabNotes);

    new SimpleBar($tabNotes[0], {autoHide: true});
  }

  async render() {
    this.container.empty();
    const tabs = await this.getTabs();
    this.data = {...this.data, ...tabs, ...{'activeTab': this.activeTab}};
    const $editor = $(
        this.template(this.data)
    );
    this.editor = $editor.appendTo(this.container);
    if (this.menus.includes('Post Editor')) {
      this.renderTabPostEditor();
    }
    if (this.menus.includes('Content Analytics')) {
      this.renderTabContentAnalytics();
    }
    if (this.menus.includes('History')) {
      this.renderHistory().then(function () {

      });
    }
    if (this.menus.includes('Notes')) {
      this.renderNotes().then(function () {

      });
    }
    if (this.menus.length === 1) {
      this.editor.addClass('without-menus');
    } else {

    }

    this.app.initTooltip();
  }

  observe() {
    const self = this;
    const $observeManager = this.observerManager;
    let $images = $('.svg-object, .post-image', this.editor);
    $images.each(function (index, image) {
      const src = $(image).attr('data-src');
      if (!self.app.isEmpty(src)) {
        console.log(image, src);
        $observeManager.observeIntersection(image);
      }
    });
  }

  getInstance() {
    return {
      editor: this.editor
    }
  }
}


class DesignLibrary extends TableList {
  templateName = 'post_editor__design-library'

  constructor(app, container) {
    const listRow = 'post_editor__row-design-library'
    super(app, container, 'test', false);
    this.app = app;
    this.container = container;
    this.listRow = listRow;
    this.data = {};
    this.template = _.template(this.app.templates[this.templateName]);
    this.destroy();
    this.$library = $(this.template({}));
    this.$library.appendTo(this.container);
    $('[data-simplebar="init"]', this.$library).each(function () {
      app.initSimpleBar(this);
    })
    this.pageEnd = false;
  }

  setImageObserverManager(ImageObserverManager) {
    this.observerManager = ImageObserverManager;
  }

  prepareRow(row) {
    const observerManager = this.observerManager;
    let template = _.template(this.app.templates[this.listRow]);
    const $template = $(template(row));

    let $images = $('.svg-object', $template);
    $images.each(function (index, image) {
      if ($(image).attr('data-src') !== '') {
        observerManager.observeIntersection(image);
      }
    });
    return $template;
  }

  setData(data) {
    this.data = data;
  }

  destroy() {
    $('.design-library-container', this.container).remove();
  }

  loaderData = {
    id: null,
    svg: '',
    design : ''
  }

  templateIds = [];

  noMorePages() {
    return this.pageEnd;
  }

  async render() {
    //await
    const app = this.app;
    const $proPlusContainer = this.$library.find('[data-proplus-designs]');
    const $proContainer = this.$library.find('[data-pro-designs]');
    this.showLoaderInto($proPlusContainer, this.loaderData);

    const response = await this.app.apis['post'].templates(this.data.id, this.templateIds);
    this.removeLoader();

    if (response.svgs['proplus'].length === 0 && response.svgs['pro'] === 0) {
      this.pageEnd = true;
    } else {
      _.each(response.svgs['proplus'], (svg) => {
        this.templateIds.push(svg.id);
        svg = {...svg, ...{design: 'proplus'}};
        console.log(svg);
        const $row = this.prepareRow(svg);
        $row.appendTo($proPlusContainer);
      });

      _.each(response.svgs['pro'], (svg) => {
        this.templateIds.push(svg.id);
        svg = {...svg, ...{design: 'pro'}};
        console.log(svg);
        const $row = this.prepareRow(svg);
        $row.appendTo($proContainer);
      });
    }

  }

  observe() {
    const $observeManager = this.observerManager;
    let $images = $('.svg-object, .post-image', this.$library);
    $images.each(function (index, image) {
      if ($(image).attr('data-src') !== '') {
        $observeManager.observeIntersection(image);
      }
    });
  }
}